export default {
  baseURL: process.env.VUE_APP_BASE_URL,
  authURL: process.env.VUE_APP_AUTH_URL,
  redirectURI: process.env.VUE_APP_REDIRECT_URI,
  clientID: process.env.VUE_APP_CLIENT_ID,
};
